"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _loading = require("../context/loading");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function LoadedView(_ref) {
  var children = _ref.children;

  var _useLoadingContext = (0, _loading.useLoadingContext)(),
      empty = _useLoadingContext.empty,
      loading = _useLoadingContext.loading;

  return !empty && !loading ? _react2.default.createElement(_react.Fragment, null, children) : null;
}

exports.default = LoadedView;